export interface IProdServicesSection {
    id: number;
    title: string;
    icon: string;
    type: ProductsServicesSection;
    selected: boolean;
    position: number;
    info: IProdServicesInfo;
}

export interface IProdServicesInfo {
    title: string;
    subtitle?: string;
    tips: IProdServicesTip[];
}

export interface IProdServicesTip {
    image: string;
    description: string;
    externalLink?: string;
    textAction?: string;
}

export enum ProductsServicesSection {
    RenewableEnergy   = "renewable",
    ElectricMobility  = "mobility",
    EfficientHouse    = "house"
}
